// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form_field--errors[data-v-ce94af10]{margin-top:6px}", "",{"version":3,"sources":["webpack://./resources/client/components/form/FormValidationErrors.vue"],"names":[],"mappings":"AAGA,qCACE,cAFF","sourcesContent":["\n// Due to how Buefy works these styles must be in global styles\n\n.form_field--errors {\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
